/**
 * @generated SignedSource<<84444a20018c3eab0989ec24439a10b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BookmarkButtonAddMutation$variables = {
  id: string;
};
export type BookmarkButtonAddMutation$data = {
  readonly addBookmark: boolean;
};
export type BookmarkButtonAddMutation = {
  response: BookmarkButtonAddMutation$data;
  variables: BookmarkButtonAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "addBookmark",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookmarkButtonAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookmarkButtonAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0d9fe7c5ad4deab593069c1f2c86e15d",
    "id": null,
    "metadata": {},
    "name": "BookmarkButtonAddMutation",
    "operationKind": "mutation",
    "text": "mutation BookmarkButtonAddMutation(\n  $id: ID!\n) {\n  addBookmark(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "5d3c1bfaf6a4e603f64f5018270dc3a8";

export default node;
